import { useCheckUserPlan } from '@/finsight/ui/common/components/CheckUserPlanAccess/useCheckUserPlan';
import { UserPlanType } from '@/users/domain/UserPlan';

export const useDealBlur = () => {
  const planWithoutBlur = UserPlanType.PREMIUM;

  const hasAccess = useCheckUserPlan(planWithoutBlur);

  return {
    isBlurred: !hasAccess,
    planWithoutBlur,
  };
};
